import { render, staticRenderFns } from "./mobile-alert-modal.component.vue?vue&type=template&id=588bf9a6&scoped=true"
import script from "./mobile-alert-modal.component.vue?vue&type=script&lang=ts"
export * from "./mobile-alert-modal.component.vue?vue&type=script&lang=ts"
import style0 from "./mobile-alert-modal.component.vue?vue&type=style&index=0&id=588bf9a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588bf9a6",
  null
  
)

export default component.exports